export type GeiVersionState = 'OPEN' | 'CLOSED';

export interface GeiInventoryVersion {
    id: string;
    geiInventoryId: string;
    versionNumber: number;
    label: string | null;
    state: GeiVersionState;
    organizationId: string;
    year: number;
    predecessorVersionId: string | null;
    correctionReason: string | null;
    createdBy: string | null;
    createdByName?: string | null;
    createdAt: string;
    closedBy: string | null;
    closedByName?: string | null;
    closedAt: string | null;
    isCurrent: boolean;
}

export interface GeiInventoryListItem {
    id: string;
    year: number;
    personCharge?: string;
    description?: string;
    msIdentity_organization_id?: string;
    msidentityOrganizationName?: string;
}

export const CURRENT_VERSION_VALUE = 'current';
